import {
  CLEAN_APPOINTMENTS,
  CLEAN_BONUS,
  CLEAN_COMMISSIONS,
  CLEAN_DASHBOARD,
  CLEAN_LEADS,
  CLEAN_MARKETING_ANNOUNCEMENTS,
  CLEAN_NOTIFICATIONS,
  CLEAN_SITE,
  CLEAN_USER,
  LOG_OUT,
  IS_LOGGING_IN
} from 'constants/types';
import firebase from 'firebase/compat/app';
import { siteLoaded, siteLoading } from './site';

import queryClient from 'lib/queryClient';
import { getUser } from './user';
import getLoginErrors from 'views/Login/getLoginErrors';
import 'firebase/compat/auth';

export const setIsLoggingIn = payload => {
  return {
    type: IS_LOGGING_IN,
    payload
  };
};

export const LogIn = (userData, setUserData) => {
  return async dispatch => {
    console.log('LogIn');
    console.log(userData);
    localStorage.removeItem('oneill_tour_completed_v1');
    localStorage.removeItem('oneill_tour_first_done');
    localStorage.removeItem('oneill_tour_zoho_sent_v1');
    dispatch(setIsLoggingIn(true));
    firebase
      .auth()
      .signInWithEmailAndPassword(userData.email, userData.password)
      .then(user => {
        console.log('/---/');
        console.log(user);
        dispatch(getUser(user, userData, setUserData));
        dispatch(setIsLoggingIn(false));
        dispatch(siteLoading());
      })
      .catch(error => {
        console.error(error);
        setUserData({
          ...userData,
          errors: { email: '', password: '', ...getLoginErrors(error) }
        });
        dispatch(setIsLoggingIn(false));
      });
  };
};

export const LogOut = () => async dispatch => {
  dispatch(siteLoading());
  await firebase.auth().signOut();
  localStorage.removeItem('oneill_tour_completed_v1');
  localStorage.removeItem('oneill_tour_first_done');
  localStorage.removeItem('oneill_tour_zoho_sent_v1');
  // the query cache is global and outlives unmounting, so it has to be wiped or a
  // second user signing in on the same tab would see the previous one's data
  queryClient.clear();
  dispatch({ type: LOG_OUT });
  dispatch({ type: CLEAN_USER });
  dispatch({ type: CLEAN_DASHBOARD });
  dispatch({ type: CLEAN_APPOINTMENTS });
  dispatch({ type: CLEAN_BONUS });
  dispatch({ type: CLEAN_COMMISSIONS });
  dispatch({ type: CLEAN_LEADS });
  dispatch({ type: CLEAN_MARKETING_ANNOUNCEMENTS });
  dispatch({ type: CLEAN_NOTIFICATIONS });
  dispatch({ type: CLEAN_SITE });
  dispatch(siteLoaded());
};
